import { gql } from "@apollo/client";

export const CREATE_INVOICE_PRODUCT_QUOTATION = gql`
  mutation createInvoiceProductQuotation(
    $input: createInvoiceProductQuotationInput
  ) {
    createInvoiceProductQuotation(input: $input) {
      Id
      serviceName
      productDetails
      totalActualPrice
      totalDiscount
      grandTotal
      createdAt
    }
  }
`;

export const GET_ALL_INVOICE_PRODUCT_QUOTATIONS = gql`
  query getAllInvoiceProductQuotations {
    getAllInvoiceProductQuotations {
      Id
      serviceName
      productDetails
      totalActualPrice
      totalDiscount
      grandTotal
      createdAt
    }
  }
`;

export const GET_INVOICE_PRODUCT_QUOTATION_BY_ID = gql`
  query getInvoiceProductQuotationById($Id: Int) {
    getInvoiceProductQuotationById(Id: $Id) {
      Id
      serviceName
      productDetails
      totalActualPrice
      totalDiscount
      grandTotal
      createdAt
    }
  }
`;

export const DELETE_INVOICE_PRODUCT_QUOTATION_BY_ID = gql`
  mutation deleteInvoiceProductQuotationById($Id: Int) {
    deleteInvoiceProductQuotationById(Id: $Id)
  }
`;
